// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './certidao-nao-submissao.scss';

// Redux
import AssociateService from '../../../redux/services/associate';
import { updateBasket, updatePublicBuyer } from '../../../redux/actions/order';
import { connect } from 'react-redux';

// Utils
import { validateNIF } from '../../../common/utils/validation-utils';
import { PRODUCT_KEY_EMAIL, PRODUCT_KEY_FISCAL_NUMBER, PRODUCT_KEY_IDENTIFICATION_NUMBER, PRODUCT_KEY_NAME, PRODUCT_KEY_PHONE_NUMBER } from '../../../common/constants';
import { COUNCIL_LIST, DCF_LIST, DISTRICT_LIST } from '../../../common/lists/dcf';
import { STREET_TYPE_LIST } from '../../../common/lists/personal';
import { PORTUGAL, WORLD_LIST } from '../../../common/lists/countries';

class CertidaoNaoSubmissaoComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            cc: "",
            nif: "",
            nifCountry: null,
            email: "",
            phoneNumber: "",
            streetType: null,
            streetTypePlaceholder: "",
            addressLine: "",
            doorFloor: "",
            doorNumber: "",
            auxPlace: "",
            cP4: "",
            cp3: "",
            city: "",
            county: null,
            district: null,
            agreement: false,
            agreement2: false,
            validRequest: true,
            validName: true,
            validCC: true,
            validCCFormat: true,
            validNIF: true,
            validNIFFormat: true,
            validNifCountry: true,
            validEmail: true,
            validEmailFormat: true,
            validMobilePhone: true,
            validMobilePhoneFormat: true,
            validAgreement: true,
            validCpFormat: true,
            validAssociate: true
        }
    }

    updateFormComponent(column, value) {

        if(column === "county") {
            for (let i = 0; i < DCF_LIST.length; i++) {
                if(DCF_LIST[i].council === value.code) {
                    this.setState({
                        [column]: value,
                        district: { code: DCF_LIST[i].district, name: DCF_LIST[i].district }
                    });
                }
            }
        }
        else if(column === "streetType") {
            this.setState({
                [column]: value,
                streetTypePlaceholder: value.name
            });
        }
        else {
            this.setState({
                [column]: value
            })
        }

    }

    submitAcquisition() {
        if(this.validateForm()) {
            AssociateService.checkAssociateExists({
                nif: this.state.nif,
                cc: this.state.cc,
                registrationRef: null
            }).then((response) => { 
                if(response.exists !== true) {
                    let buyer = {
                        associateId: null,
                        name: this.state.name, 
                        email: this.state.email, 
                        nif: this.state.nif,
                        nifCountry: this.state.nifCountry?.name,
                        identificationNumber: this.state.cc,
                        streetType: this.state.streetType?.name,
                        streetTypePlaceHolder: this.state.streetTypePlaceholder, 
                        addressLine: this.state.addressLine,
                        doorNumber: this.state.doorNumber, 
                        doorFloor: this.state.doorFloor,
                        auxPlace: this.state.auxPlace,
                        cp4: this.state.cP4, 
                        cp3: this.state.cp3, 
                        city: this.state.city,
                        county: this.state.county?.name, 
                        district: this.state.district?.name, 
                        phoneNumber: this.state.phoneNumber 
                    };

                    let metadata = [
                        { key: PRODUCT_KEY_NAME, value: this.state.name },
                        { key: PRODUCT_KEY_IDENTIFICATION_NUMBER, value: this.state.cc },
                        { key: PRODUCT_KEY_FISCAL_NUMBER, value: this.state.nif },
                        { key: PRODUCT_KEY_EMAIL, value: this.state.email },
                        { key: PRODUCT_KEY_PHONE_NUMBER, value: this.state.phoneNumber },
                    ];
        
                    // Add product to basket
                    let product = this.props.product;
                    product.title = this.props.t("products.products." + product.title);
                    product.metadata = metadata;

                    let products = [];

                    for (let i = 0; i < this.props.basketProducts.length; i++) {
                        products.push(this.props.basketProducts[i]);
                    }
        
                    products.push(product);

                    this.props.updateBasket(products, this.props.basketTrainings);
                    this.props.updatePublicBuyer(buyer);
                    this.props.onClose();
                }
                else {
                    this.setState({
                        validAssociate: false
                    })
                }
            })
            .catch(error => { });
        }
    }

    validateForm() {
        // Email address custom validation
        let validEmail = (this.state.email !== "");
        let validEmailFormat = true;

        if(validEmail) {
            validEmailFormat = (this.state.email.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) !== null);
        }

        // Telephone numbers custom validation
        let validMobilePhone = (this.state.phoneNumber !== "");
        let validMobilePhoneFormat = true;

        if(validMobilePhone) {
            validMobilePhoneFormat = (this.state.phoneNumber.match(/^[0-9]+$/) !== null);
        }

        // NIF custom validation
        let validNIF = (this.state.nif !== null && this.state.nif !== "");
        let validNifCountry = (this.state.nifCountry !== null);

        let validNIFFormat = true;

        if(validNIF && validNifCountry && this.state.nifCountry.code === PORTUGAL.code) {
            validNIFFormat = validateNIF(this.state.nif);
        }

        // CC custom validation
        let validCC = (this.state.cc !== null && this.state.cc !== "");
        let validCCFormat = true;

        if(validCC) {
            //validCCFormat = !isNaN(this.state.cc); - Not valid for non portuguese citizens
        }

        // Postal code custom validation
        let validCp = (this.state.cP4 !== "" && this.state.cP3 !== "");
        let validCpFormat = true;

        if(validCp) {
            validCpFormat = (this.state.cP4.match(/^[0-9]+$/) !== null) && (this.state.cP3.match(/^[0-9]+$/) !== null);
        }

        this.setState({
            validAgreement: this.state.agreement !== false && this.state.agreement2 !== false,            
            validName: this.state.name !== "",
            validNIF: validNIF,
            validNIFFormat: validNIFFormat,
            validNifCountry: validNifCountry,
            validEmail: validEmail,
            validEmailFormat: validEmailFormat,
            validMobilePhone: validMobilePhone,
            validMobilePhoneFormat: validMobilePhoneFormat,
            validCC: validCC,
            validCCFormat: validCCFormat,
            validCpFormat: validCpFormat,
            validAssociate: true
        });

        let validationResult = (this.state.agreement !== false && this.state.agreement2 !== false && this.state.name !== "" && validNIF && validNIFFormat && validNifCountry && validEmail && validEmailFormat && validMobilePhone && validMobilePhoneFormat && validCC && validCCFormat && validCpFormat);

        return validationResult;
    }

    render() {
        return (
            <div className="grid mgt-10">
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.product-form")}</b>
                </div>
                <div className="col-12">
                    <div className="flex flex-column gap-2">
                        <label htmlFor="name">{this.props.t("products.labels.name")}<span className="invalid-message">*</span></label>
                        <InputText value={this.state.name} id="name" type="text" onChange={(evt) => this.updateFormComponent("name", evt.target.value)}/>
                        { this.state.validName ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                    </div>
                </div>
                <div className='col-12 md:col-12 lg:col-2 t-align-left'>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="streetType">{this.props.t("profile.areas.personal.street-type")}</label>
                        <Dropdown showClear={true} value={this.state.streetType} id="streetType" options={STREET_TYPE_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("streetType", evt.value)}></Dropdown>
                    </div>
                </div>
                <div className='col-12 md:col-12 lg:col-5 t-align-left'>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="address1">{this.props.t("profile.areas.personal.address-line")}</label>
                        <InputText maxLength="100" value={this.state.addressLine} id="address1" type="text" onChange={(evt) => this.updateFormComponent("addressLine", evt.target.value)} />
                    </div>
                </div>
                <div className='col-12 md:col-12 lg:col-1 t-align-left'>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="doorNumber">{this.props.t("profile.areas.personal.door-number")}</label>
                        <InputText value={this.state.doorNumber} id="doorNumber" type="text" onChange={(evt) => this.updateFormComponent("doorNumber", evt.target.value)} />
                    </div>
                </div>
                <div className='col-12 md:col-12 lg:col-1 t-align-left'>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="doorFloor">{this.props.t("profile.areas.personal.door-floor")}</label>
                        <InputText value={this.state.doorFloor} id="doorFloor" type="text" onChange={(evt) => this.updateFormComponent("doorFloor", evt.target.value)} />
                    </div>
                </div>                
                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="auxPlace">{this.props.t("profile.areas.personal.aux-place")}</label>
                        <InputText value={this.state.auxPlace} id="auxPlace" type="text" onChange={(evt) => this.updateFormComponent("auxPlace", evt.target.value)} />
                    </div>
                </div>
                <div className='col-6 md:col-6 lg:col-2 t-align-left'>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="cp4">{this.props.t("profile.areas.personal.postal-code")}</label>
                        <InputText value={this.state.cP4} id="cp4" type="text" pattern="\d*" maxLength="4" onChange={(evt) => this.updateFormComponent("cP4", evt.target.value)}  />
                        { this.state.validCpFormat ? null : <small className="p-error">{this.props.t("general.wrong-cp-format")}</small>  }
                    </div>
                </div>
                <div className='col-6 md:col-6 lg:col-1 t-align-left' style={{marginTop:"21px"}}>
                    <div className="flex flex-column gap-2">
                        <InputText value={this.state.cP3} id="cp3" type="text" pattern="\d*" maxLength="3" onChange={(evt) => this.updateFormComponent("cP3", evt.target.value)}  />
                    </div>
                </div>
                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="city">{this.props.t("profile.areas.personal.city")}</label>
                        <InputText value={this.state.city} id="city" type="text" onChange={(evt) => this.updateFormComponent("city", evt.target.value)}  />
                    </div>
                </div>
                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="county">{this.props.t("profile.areas.personal.council")}</label>
                        <Dropdown id="county" value={this.state.county} options={COUNCIL_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("county", evt.value)}></Dropdown>
                    </div>
                </div>
                <div className='col-12 md:col-12 lg:col-3 t-align-left'>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="district">{this.props.t("profile.areas.personal.district")}</label>
                        <Dropdown id="district" value={this.state.district} disabled={true} options={DISTRICT_LIST} optionLabel="name"></Dropdown>
                    </div>
                </div>
                <div className="col-12 md:col-12 lg:col-2 t-align-left">
                    <div className="flex flex-column gap-2 mgt-10">
                        <label htmlFor="name">{this.props.t("products.labels.cc")}<span className="invalid-message">*</span></label>
                        <InputText value={this.state.cc} id="cc" type="text" onChange={(evt) => this.updateFormComponent("cc", evt.target.value)}/>
                        { this.state.validCC ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                        { /* this.state.validCCFormat ? null : <small className="p-error">{this.props.t("general.wrong-cc-format")}</small>  */}
                    </div>
                </div>
                <div className="col-12 md:col-12 lg:col-2 t-align-left">
                    <div className="flex flex-column gap-2 mgt-10">
                        <label htmlFor="name">{this.props.t("products.labels.nif")}<span className="invalid-message">*</span></label>
                        <InputText value={this.state.nif} id="nif" type="text" onChange={(evt) => this.updateFormComponent("nif", evt.target.value)}/>
                        { this.state.validNIF ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                        { this.state.validNIFFormat ? null : <small className="p-error">{this.props.t("general.wrong-nif-format")}</small>  }
                    </div>
                </div>
                <div className="col-12 md:col-12 lg:col-2 t-align-left">
                    <div className="flex flex-column gap-2 mgt-10">
                        <label htmlFor="nifCountry">{this.props.t("profile.areas.personal.nif-country")} <span className="invalid-message">*</span></label>
                        <Dropdown id="nifCountry" value={this.state.nifCountry} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.updateFormComponent("nifCountry", evt.value)}></Dropdown>
                        { this.state.validNifCountry ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                    </div>
                </div>
                <div className="col-12 md:col-12 lg:col-3 t-align-left">
                    <div className="flex flex-column gap-2 mgt-10">
                        <label htmlFor="name">{this.props.t("products.labels.email")}<span className="invalid-message">*</span></label>
                        <InputText value={this.state.email} id="email" type="text" onChange={(evt) => this.updateFormComponent("email", evt.target.value)}/>
                        { this.state.validEmail ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                        { this.state.validEmailFormat ? null : <small className="p-error">{this.props.t("general.wrong-email-format")}</small>  }
                    </div>
                </div>
                <div className="col-12 md:col-12 lg:col-3 t-align-left">
                    <div className="flex flex-column gap-2 mgt-10">
                        <label htmlFor="name">{this.props.t("products.labels.phone")}<span className="invalid-message">*</span></label>
                        <InputText value={this.state.phoneNumber} id="phoneNumber" type="text" pattern="\d*" maxLength="15" onChange={(evt) => this.updateFormComponent("phoneNumber", evt.target.value)}/>
                        { this.state.validMobilePhone ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                        { this.state.validMobilePhoneFormat ? null : <small className="p-error">{this.props.t("general.wrong-phone-format")}</small>  }
                    </div>
                </div>
                <div className="col-12">
                    <Checkbox inputId="cb-agreement-1" checked={this.state.agreement} onChange={e => this.updateFormComponent("agreement", e.checked)}></Checkbox>
                    <label htmlFor="cb-agreement-1" className="mgt-5 ml-2">{this.props.t("registration-form.step-1.agreement-1-1")} <a href="https://ordemdosfisioterapeutas.pt/politica-de-privacidade/" target="_blank">{this.props.t("registration-form.step-1.agreement-1-2")}</a> {this.props.t("registration-form.step-1.agreement-1-3")} <a href="https://ordemdosfisioterapeutas.pt/o-que-sao-cookies" target="_blank">{this.props.t("registration-form.step-1.agreement-1-4")}</a>.</label>
                </div>
                <div className="col-12">
                    <Checkbox inputId="cb-agreement-2" checked={this.state.agreement2} onChange={e => this.updateFormComponent("agreement2", e.checked)}></Checkbox>
                    <label htmlFor="cb-agreement-2" className="mgt-5 ml-2" >{this.props.t("products.labels.agreement-2")}</label><br/>
                    { this.state.validAgreement ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                    { this.state.validAssociate ? null : <small className="p-error">{this.props.t("products.labels.existing-registration").replace("{0}", this.state.name)}</small>  }
                </div>
                <div className='col-12 t-align-right'>
                    <div className="flex flex-wrap justify-content-end gap-2">
                        <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" onClick={(evt) => this.submitAcquisition() }/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) },
        updatePublicBuyer: (buyer) => { dispatch(updatePublicBuyer(buyer)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(CertidaoNaoSubmissaoComponent));